import { ApplicationController } from "../../support/application-controller";
import queryString from 'query-string';

export default class extends ApplicationController {
    static targets = ["orgList", "orgRow", "continueDeleteButton", "allDetachedNotice"];

    doImpersonateUser(e) {
        const targetUrl = e.target.dataset.impersonateUserUrl;

        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    const response = JSON.parse(xmlHttp.response);
                    window.open(response.redirectTo, "_self");
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", targetUrl);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify({}));
    }

    detachFromOrganization(e) {
        const button = e.currentTarget;
        const url = button.dataset.detachUrl;
        const row = this.orgRowTargets.find(t => t.contains(button));
        button.disabled = true;

        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4) return;
            if (xhr.status === 200) {
                if (row) row.remove();
                if (this.orgRowTargets.length === 0) {
                    if (this.hasOrgListTarget) this.orgListTarget.style.display = 'none';
                    if (this.hasAllDetachedNoticeTarget) this.allDetachedNoticeTarget.style.display = '';
                    if (this.hasContinueDeleteButtonTarget) this.continueDeleteButtonTarget.removeAttribute('disabled');
                }
            } else {
                button.disabled = false;
                console.warn(xhr.status, xhr.response);
                alert("Failed to detach user from organization. See console for details.");
            }
        };
        xhr.open("DELETE", url);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("X-CSRF-Token", this._csrfToken());
        xhr.send();
    }

    doDeleteUser(e) {
        const url = e.target.dataset.deleteUserUrl;

        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4) return;
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.response);
                window.location.href = response.redirectTo;
            } else {
                console.warn(xhr.status, xhr.response);
                let msg = "Failed to delete user.";
                try {
                    const body = JSON.parse(xhr.response);
                    if (body.error) msg = body.error;
                } catch (_) { /* ignore */ }
                alert(msg);
            }
        };
        xhr.open("DELETE", url);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("X-CSRF-Token", this._csrfToken());
        xhr.send(JSON.stringify({}));
    }

    _csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.content : '';
    }
}
